module.exports = __webpack_public_path__ + "img/Noctiluca-Process-8-mobile.c85a573c.png";